import BaseAPIRepository, { BaseAPIResponse } from 'api/base';
import { AxiosResponse } from 'axios';
import { BASE_URL } from 'const';
import { FERequestErrorsHandler } from 'utils';
import { GetCatalogProductsRequestV3 } from '.';
import { GetCatalogProductsResponseV3 } from '.';

const catalogRepositoryV3 = {
  getCatalogProducts: (
    { request, catalogId, cityId }: GetCatalogProductsRequestV3,
    signal?: AbortSignal,
  ) =>
    new Promise<GetCatalogProductsResponseV3.Response>(
      async (resolve, reject) => {
        try {
          let url: string;
          if (request) {
            const { query, limit, offset, sortName, sortDirection } = request;
            url =
              `${BASE_URL}/not-secure/api/v3/catalogs/${catalogId}/products?cityId=${cityId}` +
              `${query ? `&query=${query}` : ''}` +
              `${limit ? `&limit=${limit}` : ''}` +
              `${offset ? `&offset=${offset}` : ''}` +
              `${query ? `&query=${query}` : ''}` +
              `${sortDirection ? `&sortDirection=${sortDirection}` : ''}` +
              `${sortName ? `&sortName=${sortName}` : ''}`;
          } else
            url = `${BASE_URL}/not-secure/api/v3/catalogs/${catalogId}/products?cityId=${cityId}`;

          let result: AxiosResponse<
            BaseAPIResponse<GetCatalogProductsResponseV3.Response>
          > = await BaseAPIRepository.get<
            BaseAPIResponse<GetCatalogProductsResponseV3.Response>
          >(url, { signal });
          resolve(result.data.result);
        } catch (error: any) {
          FERequestErrorsHandler(error, reject);
        }
      },
    ),
};

export default catalogRepositoryV3;
